(() => {
  if (window.__typRecentlyViewedReady) {
    window.__typRecentlyViewedBoot?.(document);
    return;
  }
  window.__typRecentlyViewedReady = true;
  const key = 'typ-recent-product-handles';
  const read = () => {
    try { return JSON.parse(localStorage.getItem(key) || '[]').filter(Boolean); }
    catch (_) { return []; }
  };
  const remember = (handle) => {
    if (!handle) return;
    const handles = [handle, ...read().filter((item) => item !== handle)].slice(0, 8);
    try { localStorage.setItem(key, JSON.stringify(handles)); } catch (_) {}
  };
  const productHandle = (url) => {
    try { return new URL(url, location.origin).pathname.match(/^\/products\/([^/?#]+)/)?.[1] || ''; }
    catch (_) { return ''; }
  };
  const money = (cents) => new Intl.NumberFormat('en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format((Number(cents) || 0) / 100);
  const card = (product, showCompare) => {
    const cell = document.createElement('div');
    cell.className = 'typ-recent-cell';
    const article = document.createElement('article');
    article.className = 'typ-catalog-card';
    article.dataset.typProductHandle = product.handle;
    const link = document.createElement('a');
    link.href = product.url || `/products/${product.handle}`;
    const media = document.createElement('div');
    media.className = 'typ-collection-image';
    if (product.featured_image) {
      const image = document.createElement('img');
      image.src = `${product.featured_image}${product.featured_image.includes('?') ? '&' : '?'}width=900`;
      image.alt = product.title;
      image.loading = 'lazy';
      media.append(image);
    }
    const title = document.createElement('h3');
    const strong = document.createElement('strong');
    strong.textContent = product.title;
    const price = document.createElement('span');
    price.className = 'typ-collection-price';
    const variant = product.variants?.find((item) => item.available) || product.variants?.[0];
    const currentPrice = variant ? Number(variant.price) : Number(product.price);
    const comparePrice = variant ? Number(variant.compare_at_price) : 0;
    price.textContent = ' — ' + money(currentPrice);
    if (showCompare && comparePrice > currentPrice) {
      const original = document.createElement('s');
      original.textContent = money(comparePrice);
      original.style.marginInlineStart = '0.4em';
      original.style.whiteSpace = 'nowrap';
      price.append(original);
    }
    title.append(strong, price);
    link.append(media, title);
    article.append(link);
    cell.append(article);
    return cell;
  };
  const init = async (section) => {
    const grid = section.querySelector('[data-typ-recent-grid]');
    if (!grid) return;
    const referrerHandle = productHandle(document.referrer);
    if (referrerHandle) remember(referrerHandle);
    const handles = read().slice(0, Number(section.dataset.limit) || 3);
    if (!handles.length) return;
    const products = (await Promise.all(handles.map(async (handle) => {
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(handle)}.js`);
        return response.ok ? response.json() : null;
      } catch (_) { return null; }
    }))).filter(Boolean);
    if (!products.length) return;
    grid.replaceChildren(...products.map((product) => card(product, section.dataset.showCompare === 'true')));
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.typ-catalog-card a[href*="/products/"]');
    if (link) remember(productHandle(link.href));
  }, true);
  const boot = (root = document) => root.querySelectorAll('[data-typ-recently-viewed]').forEach(init);
  window.__typRecentlyViewedBoot = boot;
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => boot()) : boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
